import { GD } from "src/GD";
import { hasRole } from "src/permissions";

export const saveBanRule = async (data: unknown, userId: number, projectId: number, signal: AbortSignal) => {
	const [profile, project] = await Promise.all([GD.REQ_PROFILE.request(), GD.REQ_CURRENT_PROJECT.request()]);
	if (signal.aborted || profile?.id !== userId || project?.id !== projectId || !hasRole(profile?.projects.find(item => item.id === projectId)?.roles, "admin")) throw new Error("contextChanged");
	return GD.REQ_API.request({ method: "rules/config/save", data, expectedProjectId: projectId, signal, headers: { ignoreBusy: "true" } });
};
